const TURBAN_HATS = [
  {
    slug: "turban-black-25",
    name: "Turban",
    description: "Keeps the sun off (but the heat in)",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "blackColor",
        value: 5
      },
      {
        stat: "blackRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_black",
      frameIndex: 25
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "turban-blue-25",
    name: "Turban",
    description: "Keeps the sun off (but the heat in)",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "blueColor",
        value: 5
      },
      {
        stat: "blueRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_blue",
      frameIndex: 25
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "turban-green-25",
    name: "Turban",
    description: "Keeps the sun off (but the heat in)",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "greenColor",
        value: 5
      },
      {
        stat: "greenRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_green",
      frameIndex: 25
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "turban-orange-25",
    name: "Turban",
    description: "Keeps the sun off (but the heat in)",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "greenRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_orange",
      frameIndex: 25
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "turban-pink-25",
    name: "Turban",
    description: "Keeps the sun off (but the heat in)",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "goldRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_pink",
      frameIndex: 25
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "turban-purple-25",
    name: "Turban",
    description: "Keeps the sun off (but the heat in)",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "blueRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_purple",
      frameIndex: 25
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "turban-red-25",
    name: "Turban",
    description: "Keeps the sun off (but the heat in)",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "redColor",
        value: 5
      },
      {
        stat: "redRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_red",
      frameIndex: 25
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  },
  {
    slug: "turban-yellow-25",
    name: "Turban",
    description: "Keeps the sun off (but the heat in)",
    rarity: "common",
    slot: "hat",
    statChanges: [
      {
        stat: "goldColor",
        value: 5
      },
      {
        stat: "goldRes",
        value: 2
      }
    ],
    sprite: {
      sheet: "wardrobe/cloth/hat_yellow",
      frameIndex: 25
    },
    tags: [
      "daily-rotation"
    ],
    shopCategory: "hat"
  }
];
export {
  TURBAN_HATS
};
//# sourceMappingURL=data:application/json;base64,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
